<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <v-btn :to="{ name: 'Reports' }" color="primary" outlined right fab small class="mr-4"><v-icon>mdi-close</v-icon></v-btn>
      <div class="title primary--text">{{ section }}</div>
    </div>

    <v-flex xs12>
      <v-card class="mx-auto mt-5" tile>
        <template>
          <v-container class="mb-0 pb-0">
            <v-row>

              <!-- Filtro por periodo -->
              <v-col cols="12" md="9" class="text-right pb-0 pt-5">
                <v-btn-toggle v-model="period_filter">
                  <v-btn text small class="text-none">Hoy</v-btn>
                  <v-btn text small class="text-none">Semana</v-btn>
                  <v-btn text small class="text-none">Mes</v-btn>
                  <v-btn text small class="text-none">Año</v-btn>
                </v-btn-toggle>
              </v-col>

              <!-- Filtro por rango de fecha -->
              <v-col cols="12" md="3" class="pb-0 pt-1 text-right">
                <v-dialog ref="dialog"
                  @keydown.esc="modal=false"
                  v-model="modal"
                  :return-value.sync="dates"
                  persistent
                  width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateRangeText"
                        label="Fechas"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="dates" range>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                      <v-btn text color="primary" @click="$refs.dialog.save(dates)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
              </v-col>
            </v-row>
          </v-container>
        </template>

        <template>
          <v-data-table
              :headers="headers"
              :items="items"
              item-key="id"
              hide-default-footer
              class="elevation-1"></v-data-table>
        </template>
      </v-card>
    </v-flex>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
export default {
  name: 'paysheet',
  data () {
    return {
      section: this.$i18n.t('reports.paySheet'),
      overlay: false,
      period_filter: 1,
      modal: false,
      dates: [this.$moment().format('Y-MM-DD'), this.$moment().format('Y-MM-DD')],
      headers: [
        { text: 'Nombre', align: 'left', value: 'name', sortable: false },
        { text: 'Mensual', align: 'left', value: 'monthly', sortable: false },
        { text: 'Diario', align: 'left', value: 'diary', sortable: false }
      ],
      items: []
    }
  },
  computed: {
    // Return any computed data
    dateRangeText () {
      return this.dates.join(' al ')
    }
  }
}
</script>
